export default "/images/vendor/flag-icons/flags/4x3/mr.svg?f999a3ab03d99422445bbee5eb1a0a44";